import { render, staticRenderFns } from "./TeamRow.vue?vue&type=template&id=37c86870"
import script from "./TeamRow.vue?vue&type=script&lang=ts"
export * from "./TeamRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports